import Select from "./Select"; // [NEW] alphabetical dropdown (replaces <select>)
export default function DepartmentFilter({ departments = [], value = "", onChange, allLabel = "All departments", className = "form-control", counts = null, ...rest }) {
  return (
    <Select aria-label="Department" {...rest} className={className} value={value} onChange={(e) => onChange(e.target.value)}>
      <option value="">{allLabel}</option>
      {departments.map((d) => (
        <option key={d.id} value={d.id}>
          {d.name}{counts && counts[d.id] !== undefined ? ` (${counts[d.id]})` : ""}
        </option>
      ))}
    </Select>
  );
}

export function groupByDepartment(rows = [], getEmployee = (r) => r.employee || r) {
  const groups = new Map();
  rows.forEach((row) => {
    const emp = getEmployee(row) || {};
    const id = emp.departmentId || "none";
    if (!groups.has(id)) groups.set(id, { id, name: emp.departmentName && emp.departmentName !== "—" ? emp.departmentName : "No department", rows: [] });
    groups.get(id).rows.push(row);
  });
  return [...groups.values()].sort((a, b) => a.name.localeCompare(b.name));
}

export function countByDepartment(rows = [], getEmployee = (r) => r.employee || r) {
  return rows.reduce((acc, row) => {
    const id = (getEmployee(row) || {}).departmentId || "none";
    acc[id] = (acc[id] || 0) + 1;
    return acc;
  }, {});
}

export const inDepartment = (departmentId, getEmployee = (r) => r.employee || r) => (row) =>
  !departmentId || String((getEmployee(row) || {}).departmentId || "") === String(departmentId);
